import { cn } from '@/shared/lib/utils/cn';

/** Category eyebrow label in the signature amber mono style. */
export function CategoryPill({ category, className }: { category: string; className?: string }) {
  return (
    <span
      className={cn(
        'font-mono text-[10px] font-bold uppercase tracking-widest text-amber-500 dark:text-amber-400',
        className,
      )}
    >
      {category}
    </span>
  );
}
